import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { map, publishReplay, refCount, switchMap } from 'rxjs/operators';
import { FlightLogViewModelService } from 'src/app/core/flight-log-view-model.service';
import { FlightLogHttpClient } from 'src/app/shared/flight-log-api/flight-logs/flight-log-client.service';
import { FlightSummaryHttpClient as FlightCadSummaryHttpClient } from 'src/app/shared/flight-log-api/flights/flight-client.service';
import { FlightCadSummary } from 'src/store/flight-log/flight-log.model';
import { filterNull } from 'src/util/rxjs/operators';
import { FlightLogViewModel } from 'src/view-models/flight-log-view-model';

@Component({
  selector: 'fl-view-flight-log-page',
  templateUrl: './view-flight-log-page.component.html',
  styleUrls: ['./view-flight-log-page.component.scss'],
})
export class ViewFlightLogPageComponent implements OnInit {
  public flightLog$: Observable<FlightLogViewModel | undefined>;
  public flightSummary$: Observable<FlightCadSummary | undefined>;

  constructor(
    private route: ActivatedRoute,
    private flightLogs: FlightLogHttpClient,
    private _flightLogVm: FlightLogViewModelService,
    private flightSummaries: FlightCadSummaryHttpClient,
  ) {}

  public ngOnInit() {
    this.flightLog$ = this.route.params.pipe(
      map((_) => _.id as string | undefined),
      filterNull(),
      switchMap((flightLogId) => this.flightLogs.getById(flightLogId)),
      filterNull(),
      switchMap((fl) => this._flightLogVm.tryGetFromStore(fl)),
      publishReplay(),
      refCount(),
    );

    this.flightSummary$ = this.flightLog$.pipe(
      filterNull(),
      map((fl) => fl.flightSummaryId),
      filterNull(),
      switchMap((id) => this.flightSummaries.getById(id)),
      publishReplay(),
      refCount(),
    );
  }
}
